export default "__VITE_ASSET__yxknYHFP__"